export const ACTIVITY_TYPES = {
  ESSAY: 'ESSAY',
  ESSAY_PRELIMINARY: 'ESSAY_PRELIMINARY',
  MULTICHOICE: 'MULTICHOICE',
  MULTICHOICE_V: 'MULTICHOICE_V',
  MULTIRESPONSE: 'MULTIRESPONSE',
  SHORTANSWER: 'SHORTANSWER',
}
export const ATTEMPT_TYPE = {
  AUTOMATIC: 'automatic',
  NO_GRADE: 'no-grade',
  PENDING: 'pending',
}

export const ACTIVITY_STATUS_TYPES = {
  DELETED: 'DELETED',
  SYNCHRONIZED: 'SYNCHRONIZED',
  UNSYNCHRONIZED: 'UNSYNCHRONIZED',
}

export const TYPE_BASE_GRADE = {
  BASE_10: 10,
  BASE_100: 100,
}
